import { Box, Tooltip, Chip, Typography } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { IconButton } from "../../../../shared";

export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/admin/users/edit/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="View user" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                        borderRadius: "4px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export function RolesCellRenderer(props: any) {
    const roleNames = (props.value as string) || "";

    if (!roleNames.trim()) {
        return (
            <Box display="flex" alignItems="center" height="100%">
                <Chip
                    size="sm"
                    variant="soft"
                    color="neutral"
                    sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
                >
                    No roles
                </Chip>
            </Box>
        );
    }

    return (
        <Box display="flex" alignItems="center" gap={0.5} height="100%" flexWrap="wrap" py={0.5}>
            {roleNames.split(",").map((name) => (
                <Chip
                    key={name.trim()}
                    size="sm"
                    variant="soft"
                    color="primary"
                    sx={{ borderRadius: "4px" }}
                >
                    {name.trim()}
                </Chip>
            ))}
        </Box>
    );
}

/** e.g. May 2, 2026 · 10:00 AM */
export function DateCellRenderer(props: any) {
    if (!props.value) {
        return (
            <Box display="flex" alignItems="center" height="100%">
                <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
                    —
                </Typography>
            </Box>
        );
    }

    const date = moment(props.value);
    if (!date.isValid()) {
        return null;
    }

    return (
        <Box display="flex" flexDirection="column" justifyContent="center" height="100%" py={0.5}>
            <Typography level="body-sm" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
                {date.format("MMM D, YYYY")}
            </Typography>
            <Typography level="body-xs" sx={{ color: "text.tertiary", lineHeight: 1.3, mt: 0.15 }}>
                {date.format("h:mm A")}
            </Typography>
        </Box>
    );
}
